'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _prefix = require('../prefix');

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Support old mask-border syntax.
// See https://github.com/postcss/autoprefixer/issues/502.
exports['default'] = {
  supportedProperty: function supportedProperty(prop) {
    if (!/^mask-border/.test(prop)) return false;
    var newProp = prop.replace(/^mask-border/, 'mask-box-image');
    if (_prefix2['default'].js === 'Webkit') {
      return _prefix2['default'].css + newProp;
    }
    return prop;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-vendor/lib/plugins/mask-border-old.js
// module id = 659
// module chunks = 0